import { Origin } from "@bitwarden/web-vault/app/models/types/general-types";
import { AccountStoreModel } from "@bitwarden/web-vault/app/models/store/account.store.model";
export { AUSTRALIAN_SUPER_DEPLOYED_GRAPHQL_ORIGIN } from "./australian-super.plugin-config";

/**
 * Marker in vault `bsqId` for Australian Super plugin accounts (field is unused for Basiq on plugins).
 * Do not use `st` — that array stores sync-status link ids.
 */
export const AUSTRALIAN_SUPER_ACCOUNT_MARKER = "australian-super-plugin";

const DISPLAY_NAME_PREFIX = "Australian Super";

/**
 * Portal scrape returns the member's first name (from "Welcome …" on the dashboard).
 * Vault account label: `Australian Super (Sinan)`.
 */
export function formatAustralianSuperAccountDisplayName(
  scrapedMemberName: string | null | undefined,
): string {
  const member = (scrapedMemberName ?? "").replace(/\s+/g, " ").trim();
  if (!member) {
    return DISPLAY_NAME_PREFIX;
  }
  if (member.toLowerCase() === DISPLAY_NAME_PREFIX.toLowerCase()) {
    return DISPLAY_NAME_PREFIX;
  }
  return `${DISPLAY_NAME_PREFIX} (${member})`;
}

/** Apply plugin origin + marker for accounts created from the Super scraper. */
export function tagAustralianSuperAccountModel(model: AccountStoreModel): AccountStoreModel {
  return {
    ...model,
    ori: Origin.plugin,
    bsqId: AUSTRALIAN_SUPER_ACCOUNT_MARKER,
  };
}
